module.exports = __webpack_public_path__ + "videos/3d-export_jp.d1aea3c.mp4";